export default "__VITE_ASSET__CzAFDy_5__"